import { render, staticRenderFns } from "./IdentificacaoSaude.vue?vue&type=template&id=0c6062ee&"
import script from "./IdentificacaoSaude.vue?vue&type=script&lang=js&"
export * from "./IdentificacaoSaude.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports